import React from "react";

function Rick() {

    return (
    
        <g id="rick-and-morty">
            <iframe 
                src="https://giphy.com/embed/jRwC8yabCMxBUqsUw1" 
                width="844" 
                height="475"
                frameBorder="0" 
            >
            </iframe>
        </g>

    )

}

export default Rick

